(function () {
  const ENDPOINT = '/api/2024-07/graphql.json';
  const ACCESS_TOKEN = '3b94ea12d1444cf524c8d09d6567c97b';

  async function postGraphQL(query, variables) {
    const response = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN,
      },
      body: JSON.stringify({ query, variables }),
    });
    const json = await response.json();
    if (json.errors) {
      console.error('Bundle components GraphQL error', json.errors);
      return null;
    }
    return json.data;
  }

  // Bundle contents are fixed on the variant itself, not the cart, so this
  // queries `ProductVariant.components` directly by variant id rather than
  // through the cart — the classic AJAX cart token doesn't reliably map to
  // a Storefront API cart id on every store, but a variant id always does.
  // `productVariant(id:)` is not a root query field in the Storefront API;
  // node lookups go through `nodes(ids:)`, which also preserves input order.
  const COMPONENTS_QUERY = `
    query BundleComponents($ids: [ID!]!) {
      nodes(ids: $ids) {
        id
        ... on ProductVariant {
          components(first: 20) {
            nodes {
              quantity
              productVariant {
                title
                image { url altText }
                product { title }
              }
            }
          }
        }
      }
    }
  `;

  async function fetchComponentsByVariantId(variantIds) {
    if (!variantIds.length) return {};

    const ids = variantIds.map((id) => `gid://shopify/ProductVariant/${id}`);
    const data = await postGraphQL(COMPONENTS_QUERY, { ids });
    if (!data) return {};

    const componentsByVariantId = {};
    variantIds.forEach((id, index) => {
      componentsByVariantId[id] = data.nodes[index]?.components?.nodes || null;
    });
    return componentsByVariantId;
  }

  function buildComponentList(components) {
    const list = document.createElement('ul');
    list.className = 'cart-item__bundle-components list-unstyled';
    list.setAttribute('role', 'list');

    components.forEach((component) => {
      const li = document.createElement('li');
      li.className = 'cart-item__bundle-component';

      const variant = component.productVariant;
      const image = variant?.image;
      if (image?.url) {
        const img = document.createElement('img');
        img.className = 'cart-item__bundle-component-image';
        img.src = image.url;
        img.alt = image.altText || '';
        img.loading = 'lazy';
        img.width = 30;
        img.height = 30;
        li.appendChild(img);
      }

      const title = document.createElement('span');
      title.className = 'cart-item__bundle-component-title';
      title.textContent = `${component.quantity}× ${variant?.product?.title || ''}`;
      li.appendChild(title);

      if (variant?.title && variant.title !== 'Default Title') {
        const variantLabel = document.createElement('span');
        variantLabel.className = 'cart-item__bundle-component-variant';
        variantLabel.textContent = variant.title;
        li.appendChild(variantLabel);
      }

      list.appendChild(li);
    });

    return list;
  }

  async function renderBundleComponents() {
    const mounts = document.querySelectorAll('[data-bundle-components-mount]');
    if (!mounts.length) return;

    let cart;
    try {
      cart = await fetch('/cart.js').then((r) => r.json());
    } catch (error) {
      console.error('Failed to fetch cart', error);
      return;
    }

    const itemsByKey = new Map(cart.items.map((item) => [item.key, item]));
    const variantIds = [...new Set(cart.items.map((item) => item.variant_id))];

    let componentsByVariantId;
    try {
      componentsByVariantId = await fetchComponentsByVariantId(variantIds);
    } catch (error) {
      console.error('Failed to fetch bundle components', error);
      return;
    }

    mounts.forEach((mount) => {
      mount.innerHTML = '';
      const item = itemsByKey.get(mount.dataset.itemKey);
      const components = item && componentsByVariantId[item.variant_id];
      if (!components || !components.length) return;
      mount.appendChild(buildComponentList(components));
    });
  }

  document.addEventListener('DOMContentLoaded', renderBundleComponents);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, renderBundleComponents);
  }
})();
